import React from 'react';

function Information() {
  return (
    <section className="information wrap">
      <div className="flex-box">
        <div className="flex-left">
          <div className="wrap-title">
            <h2 lang="en">Information</h2>
            <p>공유디자이너랩 이용안내</p>
          </div>
        </div>
        <div className="flex-right">
          <div className="flex-box">
            <dl>
              <dt>이용안내</dt>
              <dd>사전 예약 필수</dd>
              <dd>0.9M ・외부 인원 이용 가능</dd>
              <dd>시간당 1팀 이용 가능 (최대 2명)</dd>
              <dd>작업 필요시 개인 노트북 지참</dd>
            </dl>
            <dl>
              <dt>이용시간 (주중)</dt>
              <dd>10:00 ~ 12:00</dd>
              <dd>13:00 ~ 15:00</dd>
              <dd>15:00 ~ 17:00</dd>
              <dd>점심시간 OFF 12:00 ~ 13:00</dd>
            </dl>
          </div>
          <div className="flex-box mt-5">
            <dl>
              <dt>시설 주소</dt>
              <dd>부산광역시 부산진구 중앙대로 694, 쥬디스태화 9층</dd>
            </dl>
            <dl>
              <dt>이용문의(취소 및 변경)</dt>
              <dd>1670-0812</dd>
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Information;
